import { render } from "./MapSidebar.vue?vue&type=template&id=04d8c9ae"
import script from "./MapSidebar.vue?vue&type=script&lang=js"
export * from "./MapSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__